import { create } from "zustand"

export const summaryStore = create((set, get) => ({
  selectedKey: "ALL",
  setSelectedKey: (selectedKey) => set({ selectedKey }),

  pageIdx: "",
  setPageIdx: (pageIdx) => set({ pageIdx }),

  chartSwitch: { bar: true, boxplot: true },
  toggleChartSwitch: (key) => {
    const { chartSwitch } = get()
    const targetKey = key === "bar" ? "boxplot" : "bar"

    // 현재 끄려는 차트가 켜져 있고, 반대쪽 차트가 이미 꺼져있는 상태에서 끄려고 할 때
    if (chartSwitch[key] && !chartSwitch[targetKey]) {
      set({
        chartSwitch: {
          [key]: false,
          [targetKey]: true
        }
      })
      return
    }

    // 일반적인 토글 동작
    set({
      chartSwitch: {
        ...chartSwitch,
        [key]: !chartSwitch[key]
      }
    })
  }
}))
